import theme from "@/styles/theme";
import Grid from "@mui/material/Grid";

export default function MusikSuchenResultsContainer({ children }) {
  return (
    <Grid
      container
      alignItems="center"
      sx={{
        [theme.breakpoints.up("sm")]: {
          transform: "translateY(-2.25rem)",
        },
      }}
    >
      {children}
    </Grid>
  );
}
